<template>
  <div ref="pieEchart" class="chart-box"></div>
</template>

<script>
  import '../../assets/plugins/map/js/china.js'
  import * as echarts from 'echarts'
  import {
    merge
  } from 'lodash'

  const option = {}
  export default {
    name:'piechart',
    props: ['chartOption'],
    data() {
      return {
        echart: null
      }
    },
    mounted() {
      echarts.dispose(this.$refs.pieEchart)
      this.echart = echarts.init(this.$refs.pieEchart)
      this.echart.setOption(merge({}, option, this.chartOption))
//      this.echart.on('click', function (params) {
//        if(params.componentType != 'graphic'){
//        }
//      })
      window.addEventListener('resize', () => {
        this.echart.resize()
    })
    },
    watch: {
      chartOption() {
        this.echart.setOption(merge({}, option, this.chartOption), true)
      }
    },
    methods: {
      clearChar(){
        echarts.dispose(this.$refs.pieEchart)
        this.echart = echarts.init(this.$refs.pieEchart)
        this.echart.clear()
//使用刚指定的配置项和数据显示图表。
        this.echart.setOption(option,true);
//清空画布，防止缓存
        this.echart.clear();
//使用刚指定的配置项和数据显示图表。
        this.echart.setOption(option,true);
      }
    }
  }
</script>
<style scoped>
  .chart-box{
    width:100%;
    height:260px;
    margin-top: -10px;
  }
  .h291{
    height:291px!important
  }
</style>